import React from "react";

function App() {
  return (
    <div className="contenedor">
      <h3>Política de privacidad de CookMade</h3>

      <ul>
        <li>
          <h4>Recopilación de Datos</h4>
          <p>CookMade no recopila ningún tipo de dato.</p>
        </li>

        <li>
          <h4>Uso de la Aplicación</h4>
          <p>
            Al usar CookMade No es necesario proporcionar información personal
            para disfrutar de la funcionalidad de la aplicación.
          </p>
        </li>

        <li>
          <h4>Almacenamiento de Datos</h4>
          <p>
            Dado que no recopilamos información personal, no almacenamos ningún
            dato de usuario en nuestros servidores.
          </p>
        </li>

        <li>
          <h4>Seguridad</h4>
          <p>
            En CookMade, nos comprometemos a garantizar la seguridad y
            privacidad de nuestros usuarios.
          </p>
        </li>

        <li>
          <h4>Enlaces Externos</h4>
          <p>CookMade no cuenta con ningun tipo de enlace externo.</p>
        </li>
      </ul>

      <p>
        Ten en cuenta que esta política de privacidad se aplica únicamente a la
        aplicación CookMade.
      </p>

      <p>
        Si tienes alguna pregunta o inquietud relacionada con nuestra política
        de privacidad, no dudes en contactarnos a través de los canales de
        soporte proporcionados en la aplicación.
      </p>
    </div>
  );
}

export default App;
